(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    // <vat-toggle> flips ALL prices on the page between ex-VAT and inc-VAT by toggling the
  // `vat-inc` class on <html>. State persists in localStorage and every toggle on the page
  // (e.g. product page + collection page slider) stays in sync.
  if (!customElements.get('vat-toggle')) {
    customElements.define(
      'vat-toggle',
      class VatToggle extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('.vat-toggle__input');
          if (!this.input) return;

          let stored = null;
          try {
            stored = localStorage.getItem('kad-vat-view');
          } catch (e) {
            /* storage blocked (private mode) — fall back to default ex-VAT */
          }
          this.input.checked = stored === 'inc';
          document.documentElement.classList.toggle('vat-inc', stored === 'inc');

          this.input.addEventListener('change', () => {
            const inc = this.input.checked;
            try {
              localStorage.setItem('kad-vat-view', inc ? 'inc' : 'ex');
            } catch (e) {
              /* ignore */
            }
            document.documentElement.classList.toggle('vat-inc', inc);
            document.querySelectorAll('vat-toggle').forEach((t) => {
              const i = t.querySelector('.vat-toggle__input');
              if (i) i.checked = inc;
            });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
